<script>
import { Bar } from "vue-chartjs";
import "@/plugins/chart";

export default {
    name: "WellnessStackedChart",
    extends: Bar,
    props: {
        labels: {
            type: Array,
            default: () => [],
        },
        datasets: {
            type: Array,
            default: () => [],
        },
        max: {
            type: Number,
            default: undefined,
        },
    },
    computed: {
        data(vm = this) {
            return {
                labels: vm.labels,
                datasets: vm.datasets.map(ds => ({ categoryPercentage: 0.7, barPercentage: 0.9, ...ds })),
            };
        },
        options(vm = this) {
            const theme = vm.$vuetify.theme.currentTheme;
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        stacked: true,
                        gridLines: { display: false },
                        ticks: { fontColor: theme.txtMuted, fontSize: 10 },
                    }],
                    yAxes: [{
                        stacked: true,
                        gridLines: { color: theme.outline, zeroLineColor: theme.outline, drawBorder: false },
                        ticks: { beginAtZero: true, max: vm.max, fontColor: theme.txtMuted, fontSize: 10, precision: 0 },
                    }],
                },
                legend: { display: false },
                tooltips: {
                    mode: "index",
                    intersect: false,
                    backgroundColor: theme.surface2,
                    titleFontColor: theme.txtPrimary,
                    bodyFontColor: theme.txtSecondary,
                    borderColor: theme.outline,
                    borderWidth: 1,
                    cornerRadius: 8,
                    xPadding: 10,
                    yPadding: 8,
                    titleFontFamily: '"Outfit", sans-serif',
                    bodyFontFamily: '"Outfit", sans-serif',
                    callbacks: {
                        label: function (tooltipItem, chartData) {
                            const ds = chartData.datasets[tooltipItem.datasetIndex] || {};
                            return `${ds.label || ''}: ${Number(tooltipItem.yLabel).toFixed(1)}`;
                        },
                    },
                },
            };
        },
    },
    mounted() {
        this.renderChart(this.data, this.options);
    },
    watch: {
        data() {
            this.renderChart(this.data, this.options);
        },
        options() {
            this.renderChart(this.data, this.options);
        },
    },
};
</script>
